<!-- <template>
	<div id="loader">
		<div class="load" :style="'border-top:2px solid '+color">
		</div>
	</div>
</template>
-->

<template>
	<div id="loader">
			<img src="@/assets/images/logo-loader.png" class="load" alt="">
			<!-- <h2 class="load-text">Figaro<span class="primary-color">.hr</span></h2> -->
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'notification',
		props: ['color'],
		computed: {
			...mapState({
				loader: (state) => state.loader
			}),
		},
	}

</script>

<style scoped>
	#loader {}
/*
	.load {
		width: 24px;
		height: 24px;
		border: 2px solid transparent;
		border-radius: 50%;
		border-top: 2px solid transparent;
		margin: auto;
		animation: roll .3s infinite linear;
	}
*/
	
	#loader {
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
	transform: translate(-50%, -50%);
  position: fixed;
  display: flex;
	flex-direction: column;
	align-items: center;
  justify-content: center;
  background-color: rgb(0, 0, 0, .8);
  z-index: 9999;
  text-align: center;
}

.load {
  z-index: 10000;
	animation: pulse 1.5s infinite linear;
}
	
.load-text {
  z-index: 10000;
	margin-top: .5em;
	color: #fff;
}

	@keyframes pulse {
		0% {
			transform: scale(.7);
		}

		50% {
			transform: scale(1);
		}
		
		100% {
			transform: scale(.7);
		}
		
	}

</style>
